import React from 'react';

const ImagePreview = ({ isOpen, imageUrl, onClose, title = "Image Preview" }) => {


  return (
    <div
      className="image-preview-overlay"
    >
      {/* Image Content Wrapper */}
      <div
        className="image-preview-body"
        style={{
          padding: '16px',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          overflow: 'auto'
        }}
      >
        <img
          src={imageUrl}
          alt="Preview Target"
          style={{
            maxWidth: '100%',
            maxHeight: 'calc(85vh - 70px)', // Account for the header height safely
            objectFit: 'contain',
            borderRadius: '6px',
          }}
        />
      </div>
    </div>
  );
};

export default ImagePreview;